import { useCallback, useRef } from 'react';
import { InputText } from '@uni-space/uni-components';
import { useTranslation } from 'react-i18next';
import { DimensionsDraft, dimensionAxes, isValidSize } from '../model/dimensions';

// Поля Д×Ш×В в см: Enter переводит на следующее поле, на последнем — вызывает onSubmit
export default function DimensionsFields({
  idPrefix,
  value,
  disabled,
  autoFocus,
  onChange,
  onSubmit,
}: {
  idPrefix: string;
  value: DimensionsDraft;
  disabled: boolean;
  autoFocus?: boolean;
  onChange: (value: DimensionsDraft) => void;
  onSubmit: () => void;
}) {
  const { t } = useTranslation();
  const inputs = useRef<(HTMLInputElement | null)[]>([]);
  const focusLength = useCallback(
    (element: HTMLInputElement | null) => {
      inputs.current[0] = element;
      if (autoFocus) element?.focus();
    },
    [autoFocus],
  );

  return (
    <div className="ct6-dimensionsFields">
      {dimensionAxes.map((axis, index) => (
        <InputText
          key={axis}
          id={`${idPrefix}-${axis}`}
          label={t(`consolidatorTracking.dimensions.${axis}`)}
          ref={
            index === 0
              ? focusLength
              : (element) => {
                  inputs.current[index] = element;
                }
          }
          type="number"
          textAlign="left"
          autoComplete="off"
          disabled={disabled}
          value={value[axis]}
          error={
            value[axis] !== '' && !isValidSize(value[axis]) ? t('consolidatorTracking.dimensions.invalid') : undefined
          }
          onChange={(next) => onChange({ ...value, [axis]: next })}
          onKeyDown={(event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            event.stopPropagation();
            if (index < dimensionAxes.length - 1) inputs.current[index + 1]?.focus();
            else onSubmit();
          }}
        />
      ))}
    </div>
  );
}
